export const formatToDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().split("T")[0]; 
};
export function formatDisplayDate(date, locale = "fr-TN") {
  if (!date) return ""

  try {
    const dateObj = date instanceof Date ? date : new Date(date)

    return dateObj.toLocaleDateString(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
  } catch (error) {
    console.error("Error formatting display date:", error)
    return date
  }
}

export function formatPrice(price, currency = "TND", locale = "fr-TN") {
  if (!price) return ""

  const numPrice = Number.parseFloat(price)
  if (isNaN(numPrice)) return price

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numPrice)
}

export function truncateText(text, maxLength = 100) {
  if (!text) return ""
  if (text.length <= maxLength) return text

  return text.substring(0, maxLength).trim() + "..."
}

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export function validatePhoneNumber(phone) {
  const phoneRegex = /^[+]?[1-9][\d]{0,15}$/
  return phoneRegex.test(phone.replace(/\s/g, ""))
}

export function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export function throttle(func, limit) {
  let inThrottle
  return function () {
    const args = arguments
    
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}

export const metaTagsPage=(data,myUrl,lang)=> {
  const langSuffixes = {
    ar: '_ar', fr: '', en: '_en', ru: '_ru', 
    zh: '_zh', ja: '_ja', ko: '_ko'
  };
  const suffix = langSuffixes[lang] || '';
  
  // Get SEO data with fallbacks
  const seo = data.seo || {};
  const metaTitle = seo[`meta_title${suffix}`];
  const metaDescription = seo[`meta_description${suffix}`] || "Découvrez notre activité en Tunisie.";
  const metaKeywords = seo[`meta_keywords${suffix}`] || "data, Tunisie, cuisine, gastronomie";
  const metaImage = data.vignette || data.cover;

  // Helper function to set meta tags
  const setMetaTag = (name, value, attribute = 'name') => {
    let tag = document.querySelector(`meta[${attribute}="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attribute, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', value);
  };

  // Set common meta tags
  document.title = metaTitle;
  setMetaTag('description', metaDescription);
  setMetaTag('keywords', metaKeywords);

  // Open Graph meta tags
  setMetaTag('og:title', metaTitle, 'property');
  setMetaTag('og:description', metaDescription, 'property');
  setMetaTag('og:image', metaImage, 'property');
  setMetaTag('og:type', 'website', 'property');

  // Twitter meta tags
  setMetaTag('twitter:card', 'summary_large_image', 'property');
  setMetaTag('twitter:title', metaTitle, 'property');
  setMetaTag('twitter:description', metaDescription, 'property');
  setMetaTag('twitter:image', metaImage, 'property');

  // Set URLs
  const urlPath = lang === 'fr' ? '' : `${lang}/`;
  const url = `https://tunisiagotravel.com/${urlPath}${myUrl}/${data.slug}`;
  setMetaTag('og:url', url, 'property');
  setMetaTag('twitter:url', url, 'property');
}
export const updateMetaTagsPage=(language, metaData, pagePath, baseUrl = 'https://tunisiagotravel.com') => {
  // Language to suffix mapping
  const langSuffixes = {
    ar: '_ar', fr: '', en: '_en', ru: '_ru',
    zh: '_zh', ja: '_ja', ko: '_ko'
  };

  // Get language suffix with fallbacks
  const suffix = langSuffixes[language] || '';
  
  // Get meta content with fallbacks
  const metaContent = {
    title: metaData[`meta_title${suffix}`] || metaData.meta_title_fr,
    description: metaData[`meta_description${suffix}`] || metaData.meta_description_fr,
    keywords: metaData[`meta_keywords${suffix}`] || metaData.meta_keywords_fr,
  };

  // Generate canonical URL
  const langPath = language === 'fr' ? '' : `${language}/`;
  const url = `${baseUrl}/${langPath}${pagePath}`;

  // Generic meta tag updater
  const setMeta = (selector, attrName, attrValue, content) => {
    let tag = document.querySelector(selector);
    if (!tag) {
      tag = document.createElement('meta');
      attrName === 'property' 
        ? tag.setAttribute('property', attrValue)
        : tag.setAttribute('name', attrValue);
      document.head.appendChild(tag);
    }
    tag.content = content;
  };

  // Update standard meta tags
  document.title = metaContent.title;
  setMeta('meta[name="description"]', 'name', 'description', metaContent.description);
  setMeta('meta[name="keywords"]', 'name', 'keywords', metaContent.keywords);

  // Update Open Graph tags
  const ogTags = {
    'og:title': metaContent.title,
    'og:description': metaContent.description,
    'og:url': url,
    'og:type': 'website',
    'og:image': metaData.ogImage || 'https://cdn.tunisiagotravel.com/unsafe/smart/activities/ballons_tgt/cover-festival-international-de-montgolfiere-balloon-event-show-tunisia-2025.png'
  };

  // Update Twitter tags
  const twitterTags = {
    'twitter:card': 'summary_large_image',
    'twitter:title': metaContent.title,
    'twitter:description': metaContent.description,
    'twitter:image': metaData.twitterImage || '/default-twitter-image.jpg',
    'twitter:url': url
  };

  // Set all social tags
  Object.entries({ ...ogTags, ...twitterTags }).forEach(([prop, content]) => {
    setMeta(`meta[property="${prop}"]`, 'property', prop, content);
  });
}

